import { render } from "./ShowingContent.vue?vue&type=template&id=634fe8ff"
import script from "./ShowingContent.vue?vue&type=script&lang=js"
export * from "./ShowingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__